import { render, staticRenderFns } from "./GradeList.vue?vue&type=template&id=67fd3091"
import script from "../../controllers/grade/grade-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/grade/grade-list.js?vue&type=script&lang=js&external"
import style0 from "./GradeList.vue?vue&type=style&index=0&id=67fd3091&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports